import React from 'react'
import styled from 'styled-components'
import {
  Modal,
  ModalHeader,
  ModalBody,
  Label,
} from 'reactstrap'
import get from 'lodash/get'
import { FONTS, COLORS } from '../../../constants'

export const Holiday = (props) => {
  const holiday_name = get(props, 'holiday_name', '-')

  return (
    <Modal
      isOpen={ get(props, 'showDetail') }
      toggle={ get(props, 'handleDetail') }
    >
      <ModalHeader toggle={ get(props, 'handleDetail') }>
        <Header>
          Holiday
        </Header>
      </ModalHeader>
      <ModalBody>
        { holiday_name }
      </ModalBody>
    </Modal>
  )
}

const Header = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.TITLE_SIZE};
  color: ${COLORS.PRIMARY_RED};
`



// WEBPACK FOOTER //
// ./src/components/timesheet/form/show-holiday.js